// api/siteSettings.js
import request from '@/utils/request'

/**
 * @description 根据域名获取站点公开配置
 * @param {string} domain - 当前站点的域名
 */
export const getSiteSettingsAPI = (domain) => {
  return request({
    // 对应后端 /site_settings/site-specific 接口
    url: '/site_settings/site-specific',
    method: 'get',
    // 对应后端的 Query 参数
    params: {
      domain
    }
  })
}